import React from 'react';

export function Field({
  label,
  hint,
  error,
  children,
  isLight,
}: {
  label: string;
  hint?: string;
  error?: string;
  children: React.ReactNode;
  isLight: boolean;
}) {
  return (
    <div>
      <label className={`block text-[11px] font-medium mb-1 ${isLight ? 'text-neutral-600' : 'text-gray-400'}`}>
        {label}
      </label>
      {children}
      {hint && !error && (
        <p className={`text-[10px] mt-0.5 ${isLight ? 'text-neutral-400' : 'text-gray-500'}`}>{hint}</p>
      )}
      {error && <p className="text-[10px] mt-0.5 text-red-500">{error}</p>}
    </div>
  );
}

export function inputClass(isLight: boolean, invalid?: boolean): string {
  const base =
    'w-full px-2.5 py-1.5 text-xs rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500';
  const tone = isLight
    ? 'bg-white border text-neutral-900 placeholder-neutral-400'
    : 'bg-neutral-800 border text-white placeholder-gray-500';
  const border = invalid
    ? 'border-red-400'
    : isLight
      ? 'border-neutral-300'
      : 'border-neutral-700';
  return `${base} ${tone} ${border}`;
}

export function btnPrimary(disabled?: boolean): string {
  return `inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-white rounded-lg transition-colors ${
    disabled ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'
  }`;
}

export function btnSecondary(isLight: boolean): string {
  return `inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
    isLight
      ? 'text-neutral-700 bg-white border border-neutral-300 hover:bg-neutral-50'
      : 'text-gray-200 bg-neutral-800 border border-neutral-700 hover:bg-neutral-700'
  }`;
}

export function SectionCard({
  title,
  description,
  isLight,
  children,
}: {
  title: string;
  description?: string;
  isLight: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      className={`rounded-lg border ${
        isLight ? 'bg-white border-neutral-200' : 'bg-neutral-900 border-neutral-800'
      }`}
    >
      <div className={`px-4 py-3 border-b ${isLight ? 'border-neutral-100' : 'border-neutral-800'}`}>
        <h3 className={`text-xs font-semibold ${isLight ? 'text-neutral-800' : 'text-white'}`}>{title}</h3>
        {description && (
          <p className={`text-[11px] mt-0.5 ${isLight ? 'text-neutral-500' : 'text-gray-400'}`}>{description}</p>
        )}
      </div>
      <div className="px-4 py-3">{children}</div>
    </div>
  );
}

export function chipClass(active: boolean, isLight: boolean): string {
  if (active) return 'bg-indigo-600 text-white border-indigo-600';
  return isLight
    ? 'bg-white text-neutral-600 border-neutral-200 hover:bg-neutral-50'
    : 'bg-neutral-800 text-gray-300 border-neutral-700 hover:bg-neutral-700';
}
